var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.61 7.534c-1.371-1.95-2.623-4.427-3.52-6.67-.16-.407-.734-.411-.909-.006-.96 2.236-2.279 4.697-3.706 6.632-.283.387.104.898.558.738l2.226-.783c.026 2.983-.069 5.972-.37 8.95a55.954 55.954 0 0 1-.74 5.106A38.087 38.087 0 0 1 5.84 26.51a.158.158 0 0 0 .083.195c.081.036.176.002.213-.078a39.404 39.404 0 0 0 1.905-4.908c.534-1.675.974-3.38 1.35-5.1.662-3.022 1.114-6.083 1.441-9.159l2.201.807c.448.163.851-.345.577-.733Z",
    fill: "url(#paint0_linear_1494_9840)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.953 16.075c-1.288-1.971-2.48-4.463-3.344-6.715-.155-.407-.675-.425-.824-.026-.817 2.2-1.955 4.615-3.202 6.505-.248.378.115.896.522.748l1.998-.726c.093 2.966.077 5.935-.127 8.888a59.7 59.7 0 0 1-.552 5.06 39.589 39.589 0 0 1-1.068 4.948c-.02.075.01.16.08.195.074.038.16.006.191-.072a39.68 39.68 0 0 0 1.612-4.834 58.722 58.722 0 0 0 1.104-5.039c.53-2.988.867-6.02 1.092-9.07l2.013.854c.41.173.763-.323.505-.716Z",
    fill: "url(#paint1_linear_1494_9840)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_9840",
    x1: 10.333,
    y1: 0.366,
    x2: -1.386,
    y2: 14.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_9840",
    x1: 18.969,
    y1: 8.833,
    x2: 8.53,
    y2: 20.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A6A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusArrows);
export default __webpack_public_path__ + "static/media/plus-arrows.a900179ba29c4a61e92f204f40c8701f.svg";
export { ForwardRef as ReactComponent };